import {UUID} from '../../../shared/types/uuid.type';
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map, tap} from 'rxjs/operators';
import {forkJoin, Observable, of} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {stopManyDvr, stopManyDvrFailure, stopManyDvrSuccess} from './dvr.stop-many.actions';
import {DvrService} from '../../../services/api/dvr/dvr.service';
import {loadRecords, manyRecordsStatusUpdated} from '../actions/records.actions';
import {DvrRecord} from '../../../services/api/dvr/dvr.model';


@Injectable()
export class DvrStopManyEffects {

  // noinspection JSUnusedGlobalSymbols
  stopManyDvr$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(stopManyDvr),
        concatMap((payload: { ids: UUID[] }) => {
          const ids: UUID[] = payload.ids;
          const requests: Observable<DvrRecord>[] = ids
            .map((id: UUID): Observable<DvrRecord> => this.service.stopRecord(id));

          return forkJoin(requests)
            .pipe(
              map(() => stopManyDvrSuccess({ids: ids})),
              catchError((error: any) => of(stopManyDvrFailure({error: error})))
            );
        }));
  });

  // noinspection JSUnusedGlobalSymbols
  stopManyDvrSuccess$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(stopManyDvrSuccess),
        tap(() =>
          this.snackBar.open('Records successfully stopped', 'Success', {duration: 3000})
        ),
        map((data: { ids: UUID[] }) =>
          manyRecordsStatusUpdated({ids: data.ids, status: 'stopping'})
        )
      );
  });

  // noinspection JSUnusedGlobalSymbols
  stopManyDvrFailure$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(stopManyDvrFailure),
        tap((error: { error: any }) =>
          this.snackBar.open(`Failed to stop records: ${error.error}`, 'Error', {duration: 3000})),
        map(() => loadRecords())
      );
  });

  constructor(
    private readonly actions$: Actions,
    private readonly service: DvrService,
    private readonly snackBar: MatSnackBar
  ) {
  }

}
